import React, { useEffect, useRef, useState } from "react";
import { RiEditLine } from "react-icons/ri";
import JobShare from "../Components/Job";
import { useObserver } from "mobx-react";
import { useStores } from "../../../store";
import { apiPostPut } from "../../../api/api_methods";
import { uploadFileToAzure } from "../../../services/azure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setDataToLocalStorage } from "../../../services/localStorage";
import { loginWarningImage } from "../../../helpers/constantVariables";
import Popup from "../../reusble_components/popup";
import { getDomainForWhiteLabeling, name } from "../../../services/white_label";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import {
  AiFillWarning,
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineIssuesClose,
  AiOutlineLeft,
  AiOutlineShareAlt,
} from "react-icons/ai";
import { AiFillCloseCircle } from "react-icons/ai";
import { IoCloudUploadOutline } from "react-icons/io5";
import { pdfjs } from "react-pdf";
import axios from "axios";
import YoutubeVideo from "./youtubeVideo";
import PurchasePopup from "../../reusble_components/PurchasePopup";
import { PurchaseCredits } from "../../dashboard/creditPoints";
import TaskPreview from "./TaskPreview";

export function PopupForUploadResume({
  popUpInitialValue,
  handlePopup,
  onClick,
  onDragOver,
  onDrop,
  resumeName,
  fileInputRef,
  selectFile,
  applyJob,
  onDelete,
  loading,
  buttontext,
  reSubmit,
}) {
  const closeThisPopUP = () => {
    handlePopup();
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };
  const { PopupStore } = useStores();

  return (
    <>
      {popUpInitialValue ? (
        <div
          onClick={closeThisPopUP}
          className="fixed w-screen h-screen z-50 inset-0 bg-black/30 backdrop-blur-sm"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
          >
            <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6 relative">
              <button
                onClick={closeThisPopUP}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <AiOutlineCloseCircle className="text-xl" />
              </button>

              <h2 className="text-xl font-medium text-gray-900 mb-6 text-center">
                Upload Resume
              </h2>

              <div
                className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors ${
                  resumeName
                    ? "border-primary/30 hover:border-primary/50 bg-primary/5"
                    : "border-gray-200 hover:border-primary/50"
                }`}
                onDragOver={onDragOver}
                onDrop={onDrop}
                onClick={selectFile}
              >
                <input
                  type="file"
                  accept=".pdf, .doc, .docx"
                  className="hidden"
                  ref={fileInputRef}
                  onChange={onClick}
                />
                {resumeName ? (
                  <>
                    <RiEditLine className="text-4xl text-primary/60 mx-auto mb-4" />
                    <p className="text-gray-600 mb-2">Click to change resume</p>
                    <button
                      className="text-primary hover:text-primary/80 transition-colors text-sm font-medium"
                      onKeyPress={handleKeyPress}
                    >
                      browse another file
                    </button>
                  </>
                ) : (
                  <>
                    <IoCloudUploadOutline className="text-4xl text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-600 mb-1">
                      Drag and drop your resume here
                    </p>
                    <p className="text-gray-500 text-xs opacity-50 text-center">
                      PDF Only
                    </p>
                    <button
                      className="text-primary hover:text-primary/80 transition-colors text-sm font-medium"
                      onKeyPress={handleKeyPress}
                    >
                      or click to browse
                    </button>
                  </>
                )}
              </div>

              {resumeName && (
                <div className="mt-6">
                  <div className="flex items-center justify-between gap-2 bg-gray-50 rounded-lg p-3">
                    <span className="text-sm text-gray-600 truncate flex-1">
                      {resumeName}
                    </span>
                    <button
                      onClick={onDelete}
                      className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      <AiFillCloseCircle className="text-lg" />
                    </button>
                  </div>

                  <button
                    className="w-full mt-4 bg-primary text-white py-2.5 px-4 rounded-lg hover:bg-primary/90 transition-colors flex items-center justify-center gap-2"
                    onClick={applyJob}
                  >
                    {loading ? (
                      <>
                        <svg
                          className="animate-spin h-5 w-5"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                          />
                        </svg>
                        <span>Processing...</span>
                      </>
                    ) : (
                      <span>
                        {buttontext === "Upload Resume"
                          ? "Update Resume"
                          : "Apply for Job"}
                      </span>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
          {PopupStore.videoPopup && <YoutubeVideo />}
        </div>
      ) : null}
    </>
  );
}

const HRInterviewOverview = ({
  showApply,
  interviewType,
  interviewLevel,
  numberOfQuestions,
  noOfFollowUps,
  customQuestions,
  forJobPost,
  onEdit,
  openAt,
  cutoff,
  cutOff,
  // userId,
  jobPostId,
  applyClick,
  isOpen,
  // showEditButton
}) => {
  const { RecuiterStore, PopupStore } = useStores();
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [searchParams] = useSearchParams();
  const isEdit = searchParams.get("isEdit");
  const id = searchParams.get("id");
  const [popUpVisible1, setPopupVisible1] = useState(false);

  const handlePopUpVisible1 = (value) => {
    setPopupVisible1(value);
  };

  const handlePopUpVisible = (value) => {
    setPopupVisible(value);
  };

  const handleLoader = (value) => {
    setLoader(value);
  };

  let isRunning = false;

  const handleOpenPopup = async () => {
    // return;
    if (isRunning) return; // Prevent execution if already running
    isRunning = true; // Set flag to true to indicate it's running
    
    try {
      // Your logic here
      console.log("hello");
      setLoader(true);
      if (isEdit) {
        const issuccess = await RecuiterStore.updateJobPost(id);
        issuccess && setPopupVisible(true);
      } else {
        const issuccess = await RecuiterStore.createJobPost();
        // RecuiterStore.postOnOtherPlatforms(jobPostId);
        issuccess && setPopupVisible(true);
      }
      setLoader(false);
    } finally {
      isRunning = false; // Reset flag to allow next execution
    }
  };

  const handleClosePopup = () => {
    // Reset job post data when closing the popup
    RecuiterStore.resetJobPostData();
    // Reset common store progress and labels
    CommonStore.setLabelActive(1, false);
    CommonStore.setLabelActive(2, false);
    CommonStore.setLabelActive(3, false);
    CommonStore.setLabelActive(4, false);
    CommonStore.setLabelActive(5, false);
    CommonStore.setLabelActive(6, false);
    CommonStore.setLabelActive(7, false);
    CommonStore.setProgress(0);
    setPopupVisible(false);
  };
  const [resume, setResume] = useState(null);
  const [resumeText, setResumeText] = useState(null);
  const [selectedResume, setselectedResume] = useState(null);
  const [showResumeCard, setShowResumeCard] = useState(false);
  const fileInputRef = useRef(null);
  const [loading, setloading] = useState(false);
  const [popupcalled, setPopupCalled] = useState(false);

  const [showLoginWarning, setshowLoginWarning] = useState(false);
  const [ApplicationOpen, setApplicationOpen] = useState(false);
  const [isApplicationOpen, setIsApplicationOpen] = useState(null);

  useEffect(() => {
    console.log(RecuiterStore?.jobPostDetails?.customSettings);
    if (openAt?.length > 0) {
      dateSetting(
        openAt
          ?.filter((item) => item.label === "jobPost")
          .map((item) => item.time)[0]
      );
    } else {
      dateSetting(1728193070000); // Default date if openAt[0] is undefined
    }
  }, []);

  const dateSetting = (date) => {
    const inputDate = new Date(date);
    console.log(date);
    // Get the current date and time
    const currentDate = new Date();
    console.log(inputDate, currentDate);
    // Check if the input date is before the current date
    setApplicationOpen(inputDate > currentDate);
    console.log(inputDate > currentDate);
    console.log(inputDate);
    console.log(currentDate);
    convertDate(date);
  };

  function convertDate(date) {
    // console.log("this is the time stamp for open at ", date);
    const convertedDate = new Date(date);
    const day = String(convertedDate.getDate()).padStart(2, "0"); // Adds leading zero if needed
    const month = String(convertedDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = convertedDate.getFullYear();
    const hour = String(convertedDate.getHours()).padStart(2, "0"); // Adds leading zero for hour
    const minute = String(convertedDate.getMinutes()).padStart(2, "0"); // Adds leading zero for minutes

    // Format as DD-MM-YYYY HH:MM
    const formattedDate = `${day}-${month}-${year} /${hour}:${minute}`;

    setIsApplicationOpen(
      `The Applications will be opened from ${formattedDate}`
    );
    // console.log("Formatted date:", formattedDate);
  }

  const { CommonStore } = useStores();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: for smooth scrolling
    });
  };

  const handleApplyForJob = async () => {
    if (localStorage.getItem("resumeText")) {
      setResumeText(await localStorage.getItem("resumeText"));
    }

    const resumeText1 = await localStorage.getItem("resumeText");

    scrollToTop();
    if (localStorage.getItem("user") === null) {
      if (applyClick) {
        applyClick();
      }
      return setshowLoginWarning(true);
    }

    if (!resume) {
      setShowResumeCard(true);
      // return alert("Please upload your resume to apply job");
    } else {
      const res = await fetchData(resume);
      if (!res) {
        return alert("Please upload a valid resume");
      }
      if (resumeText?.length < 5) {
        return alert("Please upload a valid resume");
      }
      const userDetails = JSON.parse(localStorage.getItem("user"));
      const userId = userDetails?._id;
      console.log(resumeText);
      const data = {
        userId: userId,
        jobPostId: jobPostId,
        resume: resume,
        resumeContent: resumeText1,
      };
      console.log(data);
      try {
        setloading(true);
        const apiResponse = await apiPostPut(
          data,
          "/application/new-application",
          "POST"
        );
        setloading(false);
        if (apiResponse.status === 200) {
          alert("Application submitted successfully");
          setShowResumeCard(false);
          RecuiterStore.fetchJobApplications();
          // scrollToTop();
          PopupStore.setVideoPopup(true);
          // Set bottom navigation index
          CommonStore.setBottomNavigationIndex(12);
        } else {
          alert(apiResponse?.body?.message);
          if (
            apiResponse?.body?.message ===
            "You have already applied for this job. Please check Applications page"
          ) {
            navigate("/dashboard/myapplicants");
          }
        }
      } catch (error) {
        alert("Failed to submit application");
        console.error("Error submitting application:", error);
      } finally {
        // setApplying(false);
      }
    }
  };
  const handleFileChange = async (e) => {
    console.log("handlefilechange");
    try {
      const res = await handleResumeText(e);

      if (res.length < 5) {
        handleDelete();
        return alert("Please upload a valid resume");
      }
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = randomNumber + timestamp;
      setselectedResume(e.target.files[0]);
      console.log(selectedResume);
      setloading(true);
      const fileUploaded = await uploadFileToAzure(
        filename,
        e.target.files[0],
        { action: "resume" }
      );

      const stringifiedURL = JSON.stringify(fileUploaded.url);
      localStorage.setItem("resume", stringifiedURL);
      setResume(fileUploaded.url);
      console.log(resume);
      console.log(fileUploaded.url);

      handleResumeText(e);

      setloading(false);
    } catch (error) {
      setloading(false);
      console.error("Error uploading file:", error);
    }
  };

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data; // Directly use response.data as array buffer

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      // setExtractedText(fullText);
      console.log(fullText);

      localStorage.setItem("resumeText", fullText);
      return fullText;
      // alert(true)
      // InterviewStore.setResumeText(fullText);
    } catch (error) {
      return "";
      console.error("Error fetching or parsing PDF file", error);
    }
  };

  const handleResumeText = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      // InterviewStore.setResumeFile(selectedFile);
      const fileURL = URL.createObjectURL(selectedFile);
      const res = fetchData(fileURL);
      return res;
      // const { name } = selectedFile;
      // setSelectedFileName(name); // Update the state with the filename
      // setSelectFileByUser(selectedFile);
    }
  };

  const handleDelete = () => {
    setResume(null);
    setselectedResume(null);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const file = event.dataTransfer.files[0];
    if (file) {
      fileInputRef.current.files = event.dataTransfer.files;
      handleFileChange({ target: fileInputRef.current });
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const navigate = useNavigate();

  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/`;

    console.log(signupUrl);

    navigate(signupUrl);
  };

  const link = () => {
    // Get job ID - prioritize URL parameter over store value
    const jobId = id || RecuiterStore?.jobPostId;
    
    if (!jobId) {
      return { 
        jobPostLink: "Job ID not available yet", 
        clientLink: "Job ID not available yet" 
      };
    }

    let jobPostLink =
      getDomainForWhiteLabeling() === "app.reaidy.io"
        ? `https://reaidy.io/job/${jobId}`
        : `https://${getDomainForWhiteLabeling()}/jobpost/${jobId}`;
    let clientLink = `https://${getDomainForWhiteLabeling()}/share/job-applicants/${jobId}`;

    return { jobPostLink: jobPostLink, clientLink: clientLink };
  };
  const link1 = () => {
    if (!jobPostId) {
      return { 
        jobPostLink: "Job ID not available yet", 
        clientLink: "Job ID not available yet" 
      };
    }

    let jobPostLink =
      getDomainForWhiteLabeling() === "app.reaidy.io"
        ? `https://reaidy.io/job/${jobPostId}`
        : `https://${getDomainForWhiteLabeling()}/jobpost/${jobPostId}`;
    let clientLink = `https://${getDomainForWhiteLabeling()}/share/job-applicants/${jobPostId}`;

    return { jobPostLink: jobPostLink, clientLink: clientLink };
  };

  //   if( coins > 2000){
  //     handleSubmit();
  //     handleClose();
  //   }
  const havingCredits = () => {
    handleOpenPopup();
    PopupStore.setPurchasePopup(false);
  };

  const interviewSetting = [
    // { id: 1, label: "Candidate Video", name: "video" },
    { id: 2, label: "Screen Recording", name: "screen" },
    { id: 3, label: "Allow Candidate to type answers", name: "typing" },
    { id: 4, label: "Allow to take Interview from Mobile", name: "mobile" },
    // { id: 5, label: "Reveal Actual answers", name: "actualAnswers" },
    // { id: 6, label: "Show report to the candidate", name: "report" },
    { id: 7, label: "Proxy Detection", name: "proxy" },
    // { id: 8, label: `Show job post in ${name()}`, name: "showJobPost" },
    { id: 9, label: "Resume", name: "resume" },
    // {
    //   id: 11,
    //   label: "Allow to change tab",
    //   name: "tabChange",
    //   tooltip: "Allow candidates to change tabs during the interview.",
    // },
    // { id: 10, label: "Candidate pay for the interview", name: "candidatePay" },
  ];

  const hiddenSettings = ["actualAnswers", "candidatePay"]; // Add the names you want to hide

  return useObserver(() => (
    <div className="container mx-auto">
      <PurchasePopup
        handleSubmit={() => {
          handleOpenPopup();
        }}
        show={PopupStore.PurchasePopup}
        handleClose={() => PopupStore.setPurchasePopup(false)}
      />
      {PopupStore.paymentGateway && (
        <PurchaseCredits
          gateWay="phonePe"
          onClose={() => {
            PopupStore.setPaymentGateway(false);
          }}
        />
      )}
      <Popup
        popUpInitialValue={showLoginWarning}
        handlePopup={() => {
          setshowLoginWarning(false);
        }}
        image={loginWarningImage}
        content="Please signup to apply for job"
        buttontext="Signup now"
        onClick={() => {
          redirectToSignupPageWithCurrentUrl();
          setshowLoginWarning(false);
        }}
        fileInputRef={fileInputRef}
      />
      <PopupForUploadResume
        popUpInitialValue={showResumeCard}
        handlePopup={() => {
          setShowResumeCard(false);
        }}
        content="Please upload your resume to apply for job"
        // buttontext="Upload Resume"
        onClick={() => {
          handleFileChange();
        }}
        onDelete={handleDelete}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        resumeName={selectedResume?.name}
        selectFile={() => fileInputRef.current.click()}
        applyJob={handleApplyForJob}
        loading={loading}
      />
      <JobShare
        isPopupVisible={popUpVisible1}
        handlePopUpVisible={handlePopUpVisible1}
        link={link1()}
        emailSubject={"Check out this job posting!"}
        emailBody={"Here's a job link you might be interested in: "}
        // interview="Job Post"
      />
      {numberOfQuestions ? (
        <div className="   border-primary border-t-0 rounded-b-2xl">
          <div className="flex justify-between items-center mb-4">
            {/* <button
            onClick={onEdit}
            className={`text-primary text-sm flex flex-row hover:underline md:-mt-10 lg:-mt-12  ${
              JSON.parse(localStorage.getItem("user"))?.role?.role === "company"
                ? "block"
                : "hidden"
            }`}
          >
            Edit details <RiEditLine className="mt-1 ml-1" />
          </button> */}
          </div>
          {isNaN(numberOfQuestions) || !numberOfQuestions ? (
            <div className="w-full md:mx-8 mx-4  mt-5 flex flex-col items-start space-y-4">
              {/* Header Section */}
              <div className="flex items-center space-x-2">
                <AiOutlineIssuesClose className="text-red-500 text-3xl" />
                <span className="text-red-500 font-bold text-lg ">
                  HR interview
                </span>
              </div>

              {/* Warning Message Section */}
              <div className="flex items-center space-x-2">
                <AiFillWarning className="text-yellow text-2xl" />
                <span className="text-yellow text-sm font-semibold">
                  You skipped this section
                </span>
              </div>

              {/* Divider */}
            </div>
          ) : (
            <div className="md:mx-8 mx-4 mt-5  pb-5 ">
              <div className="flex items-center space-x-2 mb-4">
                <AiOutlineCheckCircle className="text-green-500 text-3xl" />
                <span className="text-green-500 font-bold text-lg  ">
                  HR interview
                </span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 text-gray-800 mb-4">
                <div className="flex items-center">
                  <span className=" border-orange-600 pl-2">
                    Type of interview:{" "}
                    <span className="font-bold">
                      {numberOfQuestions !== null
                        ? interviewType === "real"
                          ? "AI"
                          : interviewType
                        : "Not added"}
                    </span>
                  </span>
                </div>
                <div className="flex items-center">
                  <span className=" pl-2">
                    Number of questions:{" "}
                    <span className="font-bold">
                      {numberOfQuestions !== null
                        ? numberOfQuestions
                        : "Not added"}
                    </span>
                  </span>
                </div>
                <div className="flex items-center">
                  <span className=" pl-2">
                    Number of followups:{" "}
                    <span className="font-bold">
                      {noOfFollowUps !== null && noOfFollowUps !== undefined && noOfFollowUps !== ""
                        ? noOfFollowUps
                        : "Not added"}
                    </span>
                  </span>
                </div>
                {interviewType === "AI interview" || interviewType === "AI HR interview" && (
                  <div className="flex items-center">
                    <span className=" pl-2">
                      Level of interview:{" "}
                      <span className="font-bold">
                        {interviewLevel || "Not added"}
                      </span>
                    </span>
                  </div>
                )}
                <div className="flex items-center">
                  <span className=" pl-2">
                    CutOff:{" "}
                    <span className="font-bold">
                      {!cutOff || cutOff === "undefined" || cutOff === ""
                        ? "Not Mentioned"
                        : cutOff + "%"}
                    </span>
                  </span>
                </div>

                {/* {forJobPost &&
              (customQuestions === "Not added" ||
              customQuestions.length === 0 ? (
                <div className="flex items-center">
                  <span className=" pl-2">
                    Custom Questions:{" "}
                    <span className="font-bold">Not added</span>
                  </span>
                </div>
              ) : (
                <div>
                  <h4 className=" mb-2 ">Custom Questions :</h4>
                  <ul className="list-decimal list-inside font-bold">
                    {customQuestions.map((question, index) => (
                      <li key={index}>{question}</li>
                    ))}
                  </ul>
                </div>
              ))} */}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="w-full md:mx-8 mx-4 mt-5 flex flex-col items-start space-y-4">
          {/* Header Section */}
          {/* <div className="flex items-center space-x-2">
            <AiOutlineIssuesClose className="text-red-500 text-3xl" />
            <span className="text-red-500 font-bold text-lg ">
              HR Interview not added
            </span>
          </div> */}
        </div>
      )}
      <TaskPreview />
      {JSON.parse(localStorage.getItem("user"))?.role?.role === "company" && (
        <div
          className=" md:px-8 px-4 p-4"
          // onClick={() =>
          //   console.log(toJS(RecuiterStore.jobPostDetails.customSettings))
          // }
        >
          {/* Heading */}
          <h2 className="text-xl font-bold mb-4">Assessment Settings</h2>

          {/* Container for options */}
          <div className="md:flex  flex  w-full flex-wrap gap-4">
          {interviewSetting
            // .filter((setting) => setting.label !== "candidatePay")
            .map((setting) => {
              const match = RecuiterStore.jobPostDetails.customSettings?.find(
                (item) => item.name === setting.name
              );
                return (
                <div key={setting.id} className="flex items-center gap-2">
                  {match?.value ? (
                    <span className="text-green-500">
                      <IoIosCheckmarkCircleOutline />
                    </span>
                  ) : (
                    <span className="text-red-500">
                      <AiOutlineCloseCircle />
                    </span>
                  )}
                  <h1 className="font-medium">{setting.label}</h1>
                </div>
              )})}
          </div>
        </div>
      )}
      {/* <div className=" md:px-8 px-4 p-4">
        <h2 className="text-lg font-bold mb-4">Assessment Schedule Time</h2>
        <div className="md:flex flex w-full flex-wrap gap-6">
          <p className="text-gray-800 pl-2">
            Start Date:{" "}
            <span className="font-bold">
              {(() => {
                try {
                  const startDateSetting = RecuiterStore?.jobPostDetails?.customSettings?.find(
                    (setting) => setting.name === "startDate"
                  );
                  
                  if (!startDateSetting?.value) return "Not specified";
                  
                  const date = new Date(startDateSetting.value);
                  return isNaN(date.getTime()) 
                    ? "Not specified" 
                    : date.toLocaleDateString("en-GB", {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      });
                } catch (error) {
                  return "Not specified";
                }
              })()}
            </span>
          </p>
          <p className="text-gray-800">
            End Date:{" "}
            <span className="font-bold">
              {(() => {
                try {
                  const endDateSetting = RecuiterStore?.jobPostDetails?.customSettings?.find(
                    (setting) => setting.name === "endDate"
                  );
                  
                  if (!endDateSetting?.value) return "Not specified";
                  
                  const date = new Date(endDateSetting.value);
                  return isNaN(date.getTime()) 
                    ? "Not specified" 
                    : date.toLocaleDateString("en-GB", {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      });
                } catch (error) {
                  return "Not specified";
                }
              })()}
            </span>
          </p>
        </div>
      </div> */}
      {forJobPost && (
        <div className="flex justify-start mx-2  ">
          <div className="flex w-[90%] md:mx-[5%]  mx-[3%] justify-between items-center gap-4 ">
            <button
              type="button"
              className="flex items-center text-primary gap-2 mt-2 mb-12"
              onClick={() => {
                CommonStore.setProgress(6);
              }}
            >
              <AiOutlineLeft /> Back
            </button>
          </div>
          <button
            className="bg-orange-500 whitespace-nowrap text-white font-bold md:py-3 py-2 md:px-12 px-7 md:text-lg text-md rounded-lg hover:bg-orange-600 mb-10 md:mr-10"
            onClick={() => {
              if (
                !JSON.parse(localStorage.getItem("user"))?.isAccountVerified
              ) {
                PopupStore.setVerify(true);
              } else {
                // if (JSON.parse(localStorage.getItem("user")).coins > 2000) {
                //   havingCredits();
                // } else if (!popupcalled) {
                //   PopupStore.setPurchasePopup(true);
                //   setPopupCalled(true);
                //   return;
                // }
                handleOpenPopup();
              }
            }}
          >
            {isEdit ?  window.location.pathname.includes("job-post") ? "Update Job" :
           window.location.pathname.includes("interview") ? "Update Interview" :
           window.location.pathname.includes("mcq") ? "Update MCQ" : "Update" :  window.location.pathname.includes("job-post") ? "Post Job" :
           window.location.pathname.includes("interview") ? "Post Interview" :
           window.location.pathname.includes("mcq") ? "Post MCQ" : "Post"}
          </button>
        </div>
      )}

      {/* {showResumeCard && (
            <div className="max-w-sm mx-auto bg-white shadow-md rounded-lg overflow-hidden mb-4">
              <div className="p-6">
                <h2 className="text-lg font-semibold text-gray-700">
                  Upload Your Resume
                </h2>
                <div className="mt-4 flex justify-center items-center">
                  <input
                    type="file"
                    accept=".pdf, .doc, .docx"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                  <button
                    onClick={() => fileInputRef.current.click()}
                    className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary focus:outline-none flex items-center justify-center"
                  >
                    {loading ? (
                      <svg
                        className="animate-spin h-5 w-5 mr-3"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        ></path>
                      </svg>
                    ) : (
                      "Choose File"
                    )}
                  </button>
                </div>
                {resume && (
                  <div className="mt-4 text-center text-gray-700">
                    <p>
                      Selected File:{" "}
                      <span className="font-bold">
                        {selectedResume?.name}
                      </span>
                    </p>
                  </div>
                )}
              </div>
            </div>
          )} */}
      {showApply && (
        <div className="flex w-full flex-col  justify-center items-center md:mb-0 lg:mb-0 mb-14 mt-[2%]">
          <input
            type="file"
            accept=".pdf, .doc, .docx"
            className="hidden"
            ref={fileInputRef}
            multiple={false}
            onChange={handleFileChange}
          />
          <p className=" rounded-t-xl rounded-bl-xl text-red-500 font-semibold">
            {ApplicationOpen ? isApplicationOpen : null}
          </p>
          <div className="flex justify-between items-end gap-2 md:gap-5 mt-5">
            {!forJobPost && (
              <div className="flex flex-col items-center justify-center">
                <div className="flex items-center justify-end w-full">
                  <button
                    className="flex justify-center items-center border bg-black text-white text-xs md:text-base  p-3 rounded-lg"
                    onClick={() => setPopupVisible1(true)}
                  >
                    <AiOutlineShareAlt className="text-lg md:text-2xl  " />
                  </button>
                </div>
              </div>
            )}
            {ApplicationOpen ? (
              <button
                onClick={() => alert(isApplicationOpen)}
                className={` bg-gray-500 text-white text-xs md:text-base md:font-medium p-3 md:px-10 rounded-md border`}
                disabled={loading}
              >
                Apply for Job
              </button>
            ) : isOpen ? (
              <button
                onClick={handleApplyForJob}
                className={` ${
                  ApplicationOpen ? "bg-gray-500" : "bg-black "
                } text-white text-xs md:text-base md:font-medium p-3 md:px-10 rounded-md border
                ${
                  JSON.parse(localStorage.getItem("user"))?.role?.role ===
                    "company" &&
                  "cursor-not-allowed"
                }
                `}
                disabled={
                  loading ||
                  JSON.parse(localStorage.getItem("user"))?.role?.role ===
                    "company"
                }
              >
                Apply for Job
              </button>
            ) : (
              <button
                onClick={null}
                className={` ${
                  ApplicationOpen ? "bg-gray-500" : "bg-red-500 "
                } text-white text-xs md:text-base cursor-not-allowed md:font-medium p-3 md:px-10 rounded-md border`}
                disabled={true}
              >
                Job Closed by Recruiter
              </button>
            )}
          </div>
          {PopupStore.videoPopup && <YoutubeVideo />}
          {/* <div>
            <div className="flex flex-row justify-center text-sm md:text-base text-[#EDAD07] mt-5 pl-4 mb-16">
              <GoAlertFill className="-mt-2 h-8 w-8" />
              <p className="pl-3">
                Make sure that you complete the interview process(all above
                mentioned fields) within 24 hours of applying for the job.
              </p>
            </div>
          </div> */}
        </div>
      )}
      <JobShare
        emailSubject={"Check out this job posting!"}
        emailBody={"Here's a job link you might be interested in: "}
        isPopupVisible={isPopupVisible}
        handlePopUpVisible={handlePopUpVisible}
        loader={loader}
        handleLoader={handleLoader}
        onClose={handleClosePopup}
        link={link()}
        jobPost={true}
        interview="Job Post"
      />
    </div>
  ));
};

export default HRInterviewOverview;
